var _defs, _path, _path2, _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _polygon2, _polygon3, _polygon4, _g, _circle, _g2, _rect14, _rect15, _path3, _path4, _polygon5, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _polygon6, _polygon7, _polygon8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "72abf1fc-af5c-4a12-adab-83afeedac95e",
    xmlns: "http://www.w3.org/2000/svg",
    width: 728,
    height: 796.38,
    viewBox: "0 0 728 796.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "44dab5fe-2df9-47ba-adb2-140775afca0e",
    x1: 506,
    y1: 757.81,
    x2: 506,
    y2: 51.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b3b3b3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b071ddd1-33a6-4512-b8b6-1cee124e019a",
    x1: 49.46,
    y1: 96.5,
    x2: 49.46,
    y2: 3.5,
    xlinkHref: "#44dab5fe-2df9-47ba-adb2-140775afca0e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d200849e-56d5-45c5-85eb-e9070e3330a6",
    x1: 627.87,
    y1: 796.38,
    x2: 627.87,
    y2: 596.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "39846f9a-c4dd-4a41-91c8-743bb7d77e65",
    x1: 627.87,
    y1: 746.82,
    x2: 627.87,
    y2: 645.68,
    xlinkHref: "#d200849e-56d5-45c5-85eb-e9070e3330a6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af8f0828-33b7-4bd6-b50f-ae3d37501acf",
    x1: 611,
    y1: 802.81,
    x2: 611,
    y2: 96.81,
    xlinkHref: "#44dab5fe-2df9-47ba-adb2-140775afca0e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "152252ce-949a-4e00-886c-6a46b2444b40",
    x1: 154.46,
    y1: 141.5,
    x2: 154.46,
    y2: 48.5,
    xlinkHref: "#44dab5fe-2df9-47ba-adb2-140775afca0e"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add file2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650,694.81c0-51.76,51.11-99.48,102.87-99.48,7.93,0,15.62-2,23-.16.1-2.26.16-15.54.16-17.82V51.81H328l-92,94.5v611.5H659C649.9,743.37,650,713.15,650,694.81Z",
    transform: "translate(-236 -51.81)",
    fill: "url(#44dab5fe-2df9-47ba-adb2-140775afca0e)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M642,704.81a117,117,0,0,1,117-117c3.53,0,7,.17,10.48.47V317h-525V745.81H649.39A116.74,116.74,0,0,1,642,704.81Z",
    transform: "translate(-236 -51.81)",
    fill: "#fcfcfc"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "533.09 269.19 6.91 269.19 6.91 94.5 92 5.5 533.09 5.5 533.09 269.19",
    fill: "#fcfcfc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 357.59,
    y: 58.59,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 357.59,
    y: 98.59,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 357.59,
    y: 138.59,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 357.59,
    y: 178.59,
    width: 142.73,
    height: 10.89,
    fill: "#5664D2",
    opacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 357.59,
    y: 218.59,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 357.59,
    y: 258.59,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 84.72,
    y: 343.59,
    width: 142.73,
    height: 10.89,
    fill: "#5664D2",
    opacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 84.72,
    y: 387.13,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 84.72,
    y: 365.36,
    width: 372.56,
    height: 10.89,
    fill: "#69f0ae",
    opacity: 0.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 84.72,
    y: 448.82,
    width: 142.73,
    height: 10.89,
    fill: "#5664D2",
    opacity: 0.5
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 84.72,
    y: 492.37,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 84.72,
    y: 470.59,
    width: 372.56,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 84.72,
    y: 554.06,
    width: 142.73,
    height: 10.89,
    fill: "#5664D2",
    opacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 84.72,
    y: 597.6,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 84.72,
    y: 575.83,
    width: 305.41,
    height: 10.89,
    fill: "#e0e0e0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "310 281 50 281 50 54 59 43 79.75 43 310 43 310 281",
    fill: "#5664D2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "4.91 96.5 94 96.5 94 3.5 4.91 96.5",
    fill: "url(#b071ddd1-33a6-4512-b8b6-1cee124e019a)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "6.91 94.5 92 94.5 92 5.5 6.91 94.5",
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 627.87,
    cy: 696.25,
    r: 100.13,
    fill: "url(#d200849e-56d5-45c5-85eb-e9070e3330a6)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 627.87,
    cy: 696.25,
    r: 93.72,
    fill: "#3ad29f"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "678.44 684.95 639.16 684.95 639.16 645.68 616.58 645.68 616.58 684.95 577.3 684.95 577.3 707.54 616.58 707.54 616.58 746.82 639.16 746.82 639.16 707.54 678.44 707.54 678.44 684.95",
    fill: "url(#39846f9a-c4dd-4a41-91c8-743bb7d77e65)"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 618.27,
    y: 653.26,
    width: 19.2,
    height: 85.97,
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 854.27,
    y: 705.07,
    width: 19.2,
    height: 85.97,
    transform: "translate(1375.93 -167.62) rotate(90)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M755,739.81c0-51.76,51.11-99.48,102.87-99.48,7.93,0,15.62-2,23-.16.1-2.26.16-15.54.16-17.82V96.81H433l-92,94.5v611.5H764C754.9,788.37,755,758.15,755,739.81Z",
    transform: "translate(-236 -51.81)",
    fill: "url(#af8f0828-33b7-4bd6-b50f-ae3d37501acf)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M747,749.81a117,117,0,0,1,117-117c3.53,0,7,.17,10.48.47V362h-525V790.81H754.39A116.74,116.74,0,0,1,747,749.81Z",
    transform: "translate(-236 -51.81)",
    fill: "#fff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "638.09 314.19 111.91 314.19 111.91 139.5 197 50.5 638.09 50.5 638.09 314.19",
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 462.59,
    y: 103.59,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 462.59,
    y: 143.59,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 462.59,
    y: 183.59,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 462.59,
    y: 223.59,
    width: 142.73,
    height: 10.89,
    fill: "#5664D2",
    opacity: 0.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 462.59,
    y: 263.59,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 462.59,
    y: 303.59,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 189.72,
    y: 388.59,
    width: 142.73,
    height: 10.89,
    fill: "#5664D2",
    opacity: 0.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 189.72,
    y: 432.13,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 189.72,
    y: 410.36,
    width: 372.56,
    height: 10.89,
    fill: "#69f0ae",
    opacity: 0.5
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 189.72,
    y: 493.82,
    width: 142.73,
    height: 10.89,
    fill: "#5664D2",
    opacity: 0.5
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 189.72,
    y: 537.37,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 189.72,
    y: 515.59,
    width: 372.56,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 189.72,
    y: 599.06,
    width: 142.73,
    height: 10.89,
    fill: "#5664D2",
    opacity: 0.5
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 189.72,
    y: 642.6,
    width: 142.73,
    height: 10.89,
    fill: "#e0e0e0"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 189.72,
    y: 620.83,
    width: 305.41,
    height: 10.89,
    fill: "#e0e0e0"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "415 326 155 326 155 99 164 88 184.75 88 415 88 415 326",
    fill: "#5664D2"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "109.91 141.5 199 141.5 199 48.5 109.91 141.5",
    fill: "url(#152252ce-949a-4e00-886c-6a46b2444b40)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "111.91 139.5 197 139.5 197 50.5 111.91 139.5",
    fill: "#fcfcfc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/add_file.8b73526518f3ac62d7da9f7a29782d99.svg";
export { ForwardRef as ReactComponent };